import React from 'react';

const CoachingWhatsIncluded = () => (
  <section id="two" className="main style3">
    <div className="grid-wrapper">
      <div className="col-12">
        <header className="major align-center">
          <h2>What&apos;s Included</h2>
        </header>
        <h3>
          Each month you receive:
        </h3>
        <ul>
          <li>
            Up to four, 50-minute coaching calls with Caitlin
          </li>
          <li>
            Weekly &quot;Wonder Experiments&quot; - a way to keep you on track
          </li>
          <li>
            Progress Tracking of key goals and hopes
          </li>
          <li>
            Direct access between sessions
          </li>
        </ul>
      </div>
    </div>
  </section>
);

export default CoachingWhatsIncluded;